export var connectScript = function (_a) {
    var src = _a.src, id = _a.id, onload = _a.onload;
    var script = document.getElementById(id);
    if (!script) {
        var node = document.getElementsByTagName("script")[0];
        var s = document.createElement("script");
        s.type = "text/javascript";
        s.src = src;
        s.async = true;
        s.id = id;
        s.onload = onload;
        var parent = node.parentNode;
        parent.insertBefore(s, node);
        return s;
    }
    else {
        return script;
    }
};
